// extracted by mini-css-extract-plugin
module.exports = {"typologyTabMobile":"TypologyTabMobile_typologyTabMobile__1hSRO","item":"TypologyTabMobile_item__3J5KJ"};